import { getPayload } from "./openPayloadToken";

export const checkoutDateSession = (token) => {
  const expiredDate = getPayload(token)?.exp;
  const dateNow = Math.floor(Date.now() / 1000);

  if (expiredDate < dateNow) {
    return {
      expired: true,
      dateExpired: expiredDate,
    };
  } else {
    return {
      expired: false,
      dateExpired: expiredDate,
    };
  }
};
